import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-pop-up-modal-custom',
    templateUrl: './pop-up-modal-custom.component.html',
    styleUrls: ['./pop-up-modal-custom.component.scss'],
})
export class PopUpModalCustomComponent {

    @Input() show = false;
    @Input() titulo = '';
    @Input() mensaje = '';
    @Input() tipo: 'info' | 'success' | 'warning' | 'error' = 'warning';
    @Input() textoBoton = 'Aceptar';
    @Input() textoBotonCancelar = '';

    @Output() cerrado = new EventEmitter<void>();
    @Output() confirmado = new EventEmitter<void>();

    iconoPorTipo(tipo: string): string {
        switch (tipo) {
            case 'info':
                return 'fas fa-info-circle';
            case 'success':
                return 'fas fa-check-circle';
            case 'error':
                return 'fas fa-times-circle';
            case 'warning':
            default:
                return 'fas fa-exclamation-triangle';
        }
    }

    cerrar(): void {
        this.show = false;
        this.cerrado.emit();
    }

    confirmar(): void {
        this.show = false;
        this.confirmado.emit();
    }
}
